<template>
  <div class="sticky-header">
    <div class="page-heading">
      <div v-if="floatingNav" class="d-flex justify-space-between items-center mt-2">
        <img
          class="hamburgerMenu"
          src="Icons_SVG/bars-solid.svg"
          alt="hamburger-menu"
          @click="
            $emit('toggle-sidebar', true);
            scrollToTop();
          "
        />
        <img
          src="img/brand/brand_logos/SVG/sense_logo_green.svg"
          class="tw-h-8 tw-mt-1 tw-ml-1 sm:tw-ml-0 sm:tw-mt-0 sm:tw-h-10 md:tw-h-12 lg:tw-h-14 tw-w-auto"
          alt="Brand Logo Full"
        />
      </div>
      <div v-if="selectedLanguage && translatedLang[pageName.trim()]" class="tw-text-[20px]">
        {{ translatedLang[pageName.trim()][selectedLanguage.key] }}
      </div>
      <div v-else>{{ pageName }}</div>
      <div class="d-flex justify-content-start align-items-center">
        <div v-if="lastUpdated" class="updatedTime mr-2">
         {{ translatedLang["Last Updated"][selectedLanguage.key] }} : {{ lastUpdated }}
        </div>
        <!-- <div
          style="font-size: 14px"
          v-if="updatedStatus && updatedStatus !== undefined"
        >
          <span :class="[`text-capitalize badge ${getClassStatusWise}`]">
            {{ updatedStatus }}
          </span>
        </div> -->
      </div>
    </div>
    <div class="d-flex align-items-center">
      <!-- <div
        v-if="selectedLanguage && translatedLang[pageName.trim()] && pageName"
        class="mx-4"
      >
        <div class="mb-1">{{ translatedLang["Select Language"][selectedLanguage.key] }}</div>
        <select
          v-model="changeLang"
          @change="handleLangChange(changeLang)"
          class="p-1"
        >
          <option v-for="lang in Languages" :key="lang.key" :value="lang.key">
            {{ lang.flag }} {{ lang.value }}
          </option>
        </select>
      </div> -->
      <div class="adminDetails card position-relative" @click="toggleUser">
        <div class="userIcon" v-if="profileDetails.profileImg == null">
          <img src="Icons_SVG/User.svg" />
        </div>
        <div class="profileImgHeader" v-if="profileDetails.profileImg">
          <img :src="profileDetails.profileImg" />
        </div>
        <div class="userControl d-flex align-items-center">
          <div class="clientName tw-hidden sm:tw-block">{{ userName }}</div>
          <!-- <div class="userLogout" @click="logout">Logout</div> -->
          <img
            src="Icons_SVG/Arrow_Left.svg"
            height="16"

            :class="[
              `${adminPopState ? 'headerIconUp' : 'headerIcondown'} tw-hidden sm:tw-block ml-2 tw-h-[16px]`,
            ]"
          />
        </div>
        <div
          class="position-absolute adminPopup bg-white pb-1 pt-1"
          v-if="adminPopState"
        >
          <div class="d-flex flex-column align-items-center py-3 px-4">
            <div class="userIcon" v-if="profileDetails.profileImg == null">
              <img src="Icons_SVG/User.svg" />
            </div>
            <div class="profileImg" v-if="profileDetails.profileImg">
              <img :src="profileDetails.profileImg" />
            </div>
            <h3 class="clientName mt-2">
              {{
                profileDetails.profileFirstName +
                " " +
                profileDetails.profileLastName
              }}
            </h3>
            <p class="mb-0">{{ profileDetails.profileEmail }}</p>
          </div>
          <div class="border-top">
            <router-link
              to="/user-management"
              class="text-decoration-none"
              v-if="admin && userRegisterKey"
            >
              <div
                class="d-flex align-items-center userProfileItem px-3 py-2 mt-1"
                @click="hideSideBar()"
              >
                <!-- <i class="fa fa-cog ml-2" style="height: 20px;"></i> -->
                <img src="Icons_SVG/Usermanagement.svg" height="20" class="ml-2" />
                <div class="userLogout ml-2">User Management</div>
              </div>
            </router-link>
            <router-link
              to="/profile"
              class="text-decoration-none"
              v-if="userRegisterKey"
            >
              <div
                class="d-flex align-items-center userProfileItem px-3 py-2 mt-1"
                @click="hideSideBar()"
              >
                <img src="Icons_SVG/Setting3.svg" height="20" class="ml-2" />
                <div class="userLogout ml-2">Account & Settings</div>
              </div>
            </router-link>
            <router-link
              to="/user-logs"
              class="text-decoration-none"
             v-if="admin && userRegisterKey"
            >
              <div
                class="d-flex align-items-center userProfileItem px-3 py-2 mt-1"
                @click="hideSideBar()"
              >
                <img src="Icons_SVG/userlogs.svg" height="20" class="ml-2" />
                <div class="userLogout ml-2">User Logs</div>
              </div>
            </router-link>
            <div
              class="d-flex align-items-center userProfileItem tw-px-[19px] py-2"
              @click="logout"
            >
              <img src="Icons_SVG/Logout.svg" height="19" class="ml-2" />
              <div class="userLogout ml-2">Logout</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "CustomHeader",
  data() {
    return {
      adminPopState: false,
      pageName: "",
      userName: JSON.parse(localStorage.reviewUserData).data.username,
      userEmail: JSON.parse(localStorage.reviewUserData).data.email,
      profileDetails: {
        profileEmail: null,
        profileFirstName: null,
        profileLastName: null,
        profileImg: null,
      },
      admin: JSON.parse(localStorage.reviewUserData).data.admin,
    //   clientRegisterCheck : JSON.parse(localStorage.clientRegister),
      userRegisterKey : JSON.parse(localStorage.reviewUserData).userRegister
    };
  },
  computed: {
    ...mapState("DemoStore", ["selectedLanguage", "translatedLang"]),
    floatingNav() {
      if (window.screen.width < 1024) {
        return true;
      } else return;
    },
    lastUpdated() {
      return this.$store.state.DemoStore.updatedDateTimeStamp;
    },
    updatedStatus() {
      return this.$store.state.DemoStore.storeUpdatedStatus;
    },
    getClassStatusWise() {
      return {
        completed: "badge-success",
        failed: "badge-danger",
        scheduled: "badge-secondary",
        running: "badge-light",
      }[this.updatedStatus];
    },
  },
  mounted() {
    (this.pageName = this.$router.history.current.name), this.getUserProfile();
    document.addEventListener("click", this.handleClickOutside);
    // this.changeLang = this.selectedLanguage;
    // this.initializeTranslation();
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    $route(newRoute) {
      this.pageName = newRoute.name;
    },
    selectedLanguage(newLang) {
      this.changeLang = newLang;
    },
  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "resetState",
      "initializeTranslation",
    ]),
    // handleLangChange() {
    //   this.setSelectedLanguage(this.changeLang);
    // },
    logout() {
      localStorage.removeItem("reviewUserData");
      sessionStorage.removeItem("reviewUserData");
      this.resetState();
      ['vuex'].forEach((key) => {
        localStorage.removeItem(key);
        sessionStorage.removeItem(key);
      });
      localStorage.clear();
      sessionStorage.clear();
      window.location.replace("#/");
      window.location.reload();
    },
    // hideSideBar(){
    // localStorage.isSideBar = "false"
    // },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    toggleUser() {
      this.adminPopState = !this.adminPopState;
    },
    getUserProfile() {
      let self = this;
      const url = "/api/v2/reviews/profile";
      self.$http
        .get(url)
        .then((res) => {
          let resData = res.body.data;
          self.profileDetails.profileEmail = resData.email;
          self.profileDetails.profileFirstName = resData.first_name;
          self.profileDetails.profileLastName = resData.last_name;
          self.profileDetails.profileImg = resData.profile_image;
          localStorage.setItem("loginUserEmail", resData.email);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleClickOutside(event) {
      const adminPopup = this.$el.querySelector(".adminPopup");
      if (
        adminPopup &&
        !adminPopup.contains(event.target) &&
        !this.$el.contains(event.target)
      ) {
        this.adminPopState = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sticky-header {
  position: sticky !important;
  top: 0 !important;
  z-index: 1000 !important;
  background-color: #fff;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center !important;
}

.hamburgerMenu {
  filter: brightness(0) saturate(100%) invert(25%) sepia(10%) saturate(5066%)
    hue-rotate(141deg) brightness(95%) contrast(95%);
  height: 25px !important;
  margin-right: 8px;
  margin-top: 4px;
}

.page-heading {
  margin-left: 1.2rem;
  padding-left: 0;
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.6px;
  color: var(--primary_brand);
  width: 30%;
}

.card {
  // border-radius: 0.7rem !important;
  // background-color: #065559;
  background-color: white;
  border: none !important;
  padding: 0.1rem !important;
  display: flex;
  justify-content: flex-start;
  height: 65px;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0.6rem 0.2rem 0 !important;
}

.userIcon {
  background: var(--primary_brand);
  border-radius: 1.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 4px;
  // margin: 0.7rem;
  // padding: 0.5rem;
}

.profileImgHeader img {
  height: 45px !important;
  padding: 0;
  border-radius: 50%;
  border: 4px solid #f0f0f0;
}

.userIcon img {
  filter: brightness(0) saturate(100%) invert(97%) sepia(3%) saturate(6%) hue-rotate(183deg) brightness(116%) contrast(100%);
  height: 42px !important;
  padding: 4px;
  border-radius: 50%;
  border: 1px solid #fff;
  outline: 1px solid #065559;
}

.profileImg img {
  height: 55px !important;
  padding: 0;
  border-radius: 50%;
  border: 4px solid #f0f0f0;
  // outline: 1px solid #065559;
}

.userControl {
  padding: 1rem 1rem 1rem 0.7rem;
}

.clientName {
  font-size: 16px;
  letter-spacing: 0.6px;
  color: var(--primary_brand);
  font-weight: 500;
  text-transform: uppercase;

  i {
    font-size: 20px !important;
  }
}

.userLogout {
  font-size: 14px;
  letter-spacing: 0.3px;
  color: #065559;
  cursor: pointer;
}

.userLogout:hover {
  color: var(--base_color);
}

.headerIcondown {
  transform: rotate(-90deg);
}

.headerIconUp {
  transform: rotate(90deg);
}

.userProfileItem:hover {
  background-color: #0655590d;
}

.adminPopup {
  min-width: 210px;
  top: 100%;
  right: 0;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
  border-radius: 10px;
}

.adminDetails {
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .page-heading {
    font-size: 17px;
    width: 35%;
  }
}

@media (min-width: 769px) and (max-width: 989px) {
  .page-heading {
    font-size: 20px;
    width: 35%;
  }
}

@media (max-width: 1500px) {
  .updatedTime {
    font-size: 12px !important;
  }
}

@media (max-width: 1024px) {
  .sticky-header {
    align-items: flex-start;
  }
}

.updatedTime {
  font-size: 14px;
  color: gray;
  font-weight: normal;
  margin-top: 5px;
}
</style>
